import React from 'react';

import Price from '../storefront/Price';
import Card from './Card';

const cdnUrl = `${
  process.env.RAZZLE_MAGENTO_MEDIA_URL
}/catalog/product/400x400`;

const ProductCard = ({
  attributes,
  hover,
  border,
  borderTopBottom,
  collapseBorder,
  rounded,

  baseUrl,
  url,
  name,
  price
}) => {
  const { image } = attributes;
  const to = `${baseUrl}${url}/`;

  return (
    <Card
      title={name}
      titleStyle="thin"
      caption={<Price price={price} />}
      imageOverlay="grey-image-background"
      url={to}
      contentAlignment="left"
      image={`${cdnUrl}${image}`}
      imagePosition="top"
      imageAlt={name}
      padding="small"
      bgColor="white"
      hasArrow={true}
      hover={hover}
      border={border}
      borderTopBottom={borderTopBottom}
      collapseBorder={collapseBorder}
      rounded={rounded}
    />
  );
};

export default ProductCard;
